import { TFunction } from 'i18next';
import { formatDateWithOffset } from 'core/utils/date-utils';
import { ProvisionedDeviceItem } from './types';

export default (t: TFunction, data: ProvisionedDeviceItem, offset: number): ProvisionedDeviceItem => {
  const fallback = t('general.not_available')

  return {
    udid: data ? data.udid : '',
    createDate: data ? formatDateWithOffset(data.createDate, offset, fallback) : fallback,
    deviceType: data ? data.deviceType : '',
    deviceFamily: data ? data.deviceFamily : '',
    lastTechnicalDataEventDate: data ? formatDateWithOffset(data.lastTechnicalDataEventDate, offset, fallback) : fallback,
    hasDeleteAction: data ? data.deviceType === 'Unmanaged' : false
  };
};

export const labelsProvDevices = (t: TFunction): ProvisionedDeviceItem => ({
  udid: t('account.provisioned_devices.column_device_id'),
  createDate: t('account.provisioned_devices.create_date.title'),
  deviceType: t('account.provisioned_devices.column_device_type'),
  deviceFamily: t('account.provisioned_devices.column_device_family'),
  lastTechnicalDataEventDate: t('account.provisioned_devices.column_last_managed')
});
